import request from "utils/request";

export async function getUserEmails() {
    return request("/rest/user_emails");
}

export async function deleteEmails(emails) {
	return request("/rest/user_emails", {
		method: "DELETE",
		body: emails
	});
}

export async function addEmail(emailAccount) {
	return request("/rest/user_emails", {
		method: "PUT",
		body: emailAccount
	})
}